// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
export default function keyInObj(value, key, obj) {
  return key in obj;
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/_keyInObj.js
// module id = 464
// module chunks = 8